import { Component } from '@angular/core';
import { ChatService } from '../service/chat.service';

type Message = {
  sender: 'user' | 'ai';
  text: string; // will hold raw HTML for the AI
};

@Component({
  selector: 'app-chat-view',
  templateUrl: './chat-view.component.html',
  styleUrls: ['./chat-view.component.scss'],
})
export class ChatViewComponent {
  userInput = '';
  answer = '';
  messages: Message[] = [];

  constructor(private chatService: ChatService) {}

  isLoading = false;

  sendMessage() {
    if (!this.userInput.trim() || this.isLoading) return;

    this.messages.push({ sender: 'user', text: this.userInput });
    const question = this.userInput;
    this.userInput = '';
    this.isLoading = true;

    this.chatService.query(question).subscribe({
      next: (res) => {
        let rawAnswer = '';

        if (res.answer) {
          rawAnswer = res.answer;

          // Remove markdown-style code nuances for json if present
          rawAnswer = rawAnswer.replace(/```json\s*([\s\S]*?)```/g, '$1').trim();
          rawAnswer = rawAnswer.replace(/```([\s\S]*?)```/g, '$1').trim();
        } else {
          rawAnswer = res;
        }

        let projectList: any[] | null = null;
        let plainText = '';

        try {
          const parsed = JSON.parse(rawAnswer);
          if (Array.isArray(parsed)) {
            projectList = parsed;
          } else {
            plainText = parsed;
          }
        } catch {
          // Not JSON, then treat as plain text
          plainText = rawAnswer;
        }

        let formatted: string;
        if (projectList) {
          formatted = projectList
            .map((p, i) => `${i + 1}. <strong>${p.title}</strong><br>${p.description}`)
            .join('<br><br>');
        } else {
          // If plainText obj, convert to JSON string with formatting:
          if (typeof plainText === 'object' && plainText !== null) {
            formatted = JSON.stringify(plainText, null, 2).replace(/\n/g, '<br>').replace(/ /g, '&nbsp;');
          } else {
            formatted = plainText;
          }
        }

        this.messages.push({ sender: 'ai', text: formatted });
        this.isLoading = false;
        console.log('Raw response:', res);
        console.log('Cleaned answer:', rawAnswer);
      },
      error: () => {
        this.messages.push({ sender: 'ai', text: 'Error contacting backend.' });
        this.isLoading = false;
      },
    });
  }
}
